import { configureStore } from '@reduxjs/toolkit'
import userReducer from './UserSlice'
import examReducer from './ExamSlice'

export default configureStore({
    reducer: {
        user: userReducer,
        exam: examReducer,
    },
    middleware : []
})